import { render, staticRenderFns } from "./LoadingLabels.vue?vue&type=template&id=07542bd0&scoped=true&"
import script from "./LoadingLabels.vue?vue&type=script&lang=js&"
export * from "./LoadingLabels.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=07542bd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07542bd0",
  null
  
)

export default component.exports